__turbopack_context__.v({
  "feedback-actions": "review-feedback-module-scss-module__y2Tj6G__feedback-actions",
  "feedback-container": "review-feedback-module-scss-module__y2Tj6G__feedback-container",
  "feedback-label": "review-feedback-module-scss-module__y2Tj6G__feedback-label",
});
